export enum BrandImpressionType {
  TILE = "TILE",
  HEADER = "HEADER",
}
